import TitleValueIcon from './TitleValueIcon';

export default TitleValueIcon;
